import type { ProjectPackageJson } from '@cli-types/next-adapter/utils.js'

export function getDeclaredRuntimePackageNames(pkg: ProjectPackageJson | null): string[] {
  if (!pkg) return []
  return Object.keys({
    ...pkg.dependencies,
    ...pkg.optionalDependencies
  })
}
